module.exports = __webpack_public_path__ + "media/newstyle/images/whatsapp-54e40fa3eb7e7b12b24c001acf85d276.svg";